import { useEffect } from 'react';

import { useQuery } from '@edreamsodigeo/frontend-api-client';

import { useLogger } from '#src/clientState/hooks';

import GET_TRIP_QUERY from './operations/query';

import type {
  Ap_GetTripQuery,
  Ap_GetTripQueryVariables,
  Buyer,
} from '#src/generated/graphql';
import type { FeapiError } from '@edreamsodigeo/frontend-api-client';

export const useGetBuyerFromTrip = ({
  token,
}): {
  buyer: Buyer;
  errors: FeapiError[] | null;
  loading: boolean;
} => {
  const { error } = useLogger();
  const { data, loading, errors } = useQuery<
    Ap_GetTripQuery,
    Ap_GetTripQueryVariables
  >(GET_TRIP_QUERY, {
    skip: !token,
    variables: {
      token,
    },
  });

  useEffect(() => {
    if (!token) {
      throw new Error('Cannot get buyer from trip: token not found');
    }
  }, [token, error]);

  return {
    buyer: data?.getTripByToken?.trip?.buyer ?? ({} as Buyer),
    errors,
    loading,
  };
};
